import React, { useState } from "react";
import axios from "axios";

function BridgeTest() {
  const [fullName, setFullName] = useState("benjamin sommerville");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const handleFetch = async () => {
    const token = process.env.REACT_APP_DATABRIDGE_KEY; // replace this with env in production
    const encodedName = encodeURIComponent(fullName);

    const url = `https://api.bridgedataoutput.com/api/v2/stellar/agents?access_token=${token}&MemberFullName=${encodeURIComponent(fullName)}`;


    try {
      console.log("Fetching:", url);
      const response = await axios.get(url);
      console.log("Response:", response.data);
      setData(response.data);
      setError("");
    } catch (err) {
      console.error("API error:", err);
      setError("Failed to fetch data. Check console.");
      setData(null);
    }
  };

  return (
    <div className="container py-4">
      <h3 className="mb-3">Bridge API Test</h3>

      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Enter Full Name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />
        <button className="btn btn-primary" onClick={handleFetch}>
          Search
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {data && (
        <div className="mt-4">
          <h5>JSON Response</h5>
          <pre style={{ maxHeight: "600px", overflow: "auto", backgroundColor: "#f8f9fa", padding: "1em" }}>
            {JSON.stringify(data, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}

export default BridgeTest;
